
import { mapGetters } from "vuex";
import CatalogoDigitalOrderPoller from "@/modules/CatalogoDigital/components/CatalogoDigitalOrderPoller.vue";

export default {
  name: "nuts",
  components: { CatalogoDigitalOrderPoller },
  computed: {
    ...mapGetters(["isAuthenticated", "empresaContexto"]),
    empresaId() {
      return Number(this.empresaContexto?.id_empresa || 0);
    },
  },
};
